import { createEmits } from '../utils/emits';

interface Events {
  /** Vue3 v-model 值更新 */
  'update:modelValue': [value: string];
  /** 值更新（Vue2 v-model / 通用监听） */
  'input': [value: string];
  /** 键盘确认/提交搜索 */
  'search': [value: string];
  /** 输入框获得焦点 */
  'focus': [e: FocusEvent];
  /** 输入框失去焦点 */
  'blur': [e: FocusEvent];
  /** 点击清除按钮 */
  'clear': [e: Event];
  /** 点击左侧返回控件 */
  'back': [e: Event];
  /** 点击取消按钮 */
  'cancel': [];
  /** 点击左侧图标 */
  'click-left-icon': [e: MouseEvent];
}

// createEmits 用于生成类型安全的 useEmits；defineEmitType 的 SortedUnionToTuple
// 约束在事件较多时顺序不稳定，emits 直接用字符串数组绕过该限制。
const { useEmits } = createEmits<Events>();

export { useEmits };

export const emits = [
  'update:modelValue',
  'input',
  'search',
  'focus',
  'blur',
  'clear',
  'back',
  'cancel',
  'click-left-icon',
];
